import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getRetailerSlice = createAsyncThunk(
  "retailer/getRetailer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/retailer/getRetailer", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getRetailerByIdSlice = createAsyncThunk(
  "retailer/getRetailerById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/retailer/getRetailerById", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const addRetailerSlice = createAsyncThunk(
  "retailer/addRetailer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/retailer/addRetailer", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateRetailerSlice = createAsyncThunk(
  "retailer/updateRetailer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/retailer/updateRetailer", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteRetailerSlice = createAsyncThunk(
  "retailer/deleteRetailer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/retailer/deleteRetailer", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
const initialState = {
  loading: false,
  retailer: [],
  retailerById: [],
  isLoading: false,
  addRetailerSuccessMessage: null,
  addRetailerErrorMessage: null,
  updateRetailerSuccessMessage: null,
  updateRetailerErrorMessage: null,
  deleteRetailerSuccessMessage: null,
  deleteRetailerErrorMessage: null,
  searchRetailerErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const retailerSlice = createSlice({
  name: "retailer",
  initialState,
  reducers: {
    resetAddRetailerMessage: (state) => {
      state.addRetailerSuccessMessage = null;
      state.addRetailerErrorMessage = null;
    },
    resetUpdateRetailerMessage: (state) => {
      state.updateRetailerSuccessMessage = null;
      state.updateRetailerErrorMessage = null;
    },
    resetDeleteRetailerMessage: (state) => {
      state.deleteRetailerSuccessMessage = null;
      state.deleteRetailerErrorMessage = null;
    },
    resetSearchRetailerMessage: (state) => {
      state.searchRetailerErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRetailerSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRetailerSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.retailer = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchRetailerErrorMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.retailer = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;   // optional, safe
        state.searchRetailerErrorMessage = null;
      })
      .addCase(getRetailerSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchRetailerErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getRetailerByIdSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRetailerByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.retailerById = action.payload.result.list;
      })
      .addCase(getRetailerByIdSlice.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addRetailerSlice.pending, (state) => {
        state.loading = true;
        state.addRetailerSuccessMessage = null;
        state.addRetailerErrorMessage = null;
      })
      .addCase(addRetailerSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.addRetailerErrorMessage = action.payload.result.message;
        } else {
          state.addRetailerSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(addRetailerSlice.rejected, (state, action) => {
        state.loading = false;
        state.addRetailerErrorMessage = action.payload.result.message;
      })
      .addCase(updateRetailerSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateRetailerSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.updateRetailerSuccessMessage = action.payload.result.message;
        } else {
          state.updateRetailerErrorMessage = action.payload.result.message;
        }
      })
      .addCase(updateRetailerSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteRetailerSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteRetailerSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.deleteRetailerSuccessMessage = action.payload.result.message;
        } else {
          state.deleteRetailerErrorMessage = action.payload.result.message;
        }
      })
      .addCase(deleteRetailerSlice.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const {
  resetAddRetailerMessage,
  resetUpdateRetailerMessage,
  resetDeleteRetailerMessage,
  resetSearchRetailerMessage,
} = retailerSlice.actions;

export default retailerSlice.reducer;
